'use client';
var xref = function(name) {
    return "___ref-" + name;
};

export { xref };
